module.exports = __webpack_public_path__ + "img/36_36.d18df26f.png";